module.exports = __webpack_public_path__ + "img/117ne.033afc86.svg";